const estadoFactura = [
    {id:"A",descripcion: "Anulado"},
    {id:"F",descripcion: "Facturado"},
    {id:"T",descripcion: "Tomado"},
    {id:"L",descripcion: "Llamado"},
    {id:"D",descripcion: "Despachado"},
    {id:"E",descripcion: "A Espera"},
    {id:"R",descripcion: "Recuperado de espera"},
    {id:"Z",descripcion: "Autorizado"},
    {id:"U",descripcion: "Recuperado via Supervision"},
    {id:"I",descripcion: "Reimpresion"},
    {id:"M",descripcion: "Movido (Despacho)"},
    {id:"V",descripcion: "Enviado a Despacho"},
    {id:"X",descripcion: "Abandonado"},
    {id:"N",descripcion: "Pedido Drive-In reemplazado (facturado)"},
    {id:"O",descripcion: "Pedido Drive-In creado"},
    {id:"H",descripcion: "Telefonico Creado"},
    {id:"W",descripcion: "Enviado desde Despacho Agrupado"},
    {id:"B",descripcion: "Anulado desde Finanzas"},
    {id:"K",descripcion: "Pedido CallCenter reemplazado (facturado)"},
    {id:"S",descripcion: "Despachado desde Casilleros"},
    {id:"P",descripcion: "Despachado desde Supervision"},
    {id:"Q",descripcion: "Bloqueo telefonico liberado"},
    {id:"C",descripcion: "Modificacion Telefonico"},
    {id:"J",descripcion: "Modificacion Telefonico Terminada"},
    {id:"Y",descripcion: "Pedido Eliminado"},
    {id:"G",descripcion: "Telefonico Movido"},
    {id:"1",descripcion: "Pedido Registrado desde App"},
    {id:"2",descripcion: "Pedido Autorizado (App, Cortesia)"},
    {id:"3",descripcion: "Pedido No Autorizado"},
    {id:"4",descripcion: "Pedido eliminado desde App"},
    {id:"5",descripcion: "Pedido Enviado a Revision"},
    {id:"6",descripcion: "Cortesia Rechazada"},
    {id:"7",descripcion: "Firma Digital de Vale"},
    {id:"8",descripcion: "Cambio de Modo de Envio Telefonico"},
    {id:"9",descripcion: "Pedido Telefonico Desatascado"},
    {id:"@",descripcion: "Pedido Reservado Procesado"},
    {id:"!",descripcion: "Marca de Demora en Facturacion"},
    {id:"#",descripcion: "Bloqueo Despacho"},
    {id:"$",descripcion: "Desbloqueo Despacho"},
    {id:"%",descripcion: "Pedido Abierto por Supervisor"},
    {id:"*",descripcion: "Refrigerio Registrado"},
    {id:"-",descripcion: "Cambio de Codigo de Cliente"},
    {id:"^",descripcion: "Entrega Anticipada de Detalles y/o Variantes (ID_PRODUCTO|CANTIDAD)"},
    {id:">",descripcion: "Derivacion a otro Call Center"},
    {id:"~",descripcion: "Pedido Entregado al Cliente"},
    {id:"=",descripcion: "Esperando pago con Transferencia/QR"},
    {id:"+",descripcion: "Cambio de Variantes"},
    {id:"<",descripcion: "Registro de Reserva"},
    {id:"/",descripcion: "Pago Transferencia/QR Confirmado"},
    {id:".",descripcion: "Tipo Pago Cambiado"}
]

function getTipo(tipo){
    var info = estadoFactura.filter((item)=>item.id==tipo);
    if(info.length!==0){
        return info[0].descripcion;
    }else{
        return ""
    }
}
export default {getTipo};